import { render } from "./AffecteRestaurantsView.vue?vue&type=template&id=97099fd6"
import script from "./AffecteRestaurantsView.vue?vue&type=script&lang=js"
export * from "./AffecteRestaurantsView.vue?vue&type=script&lang=js"

import "./AffecteRestaurantsView.vue?vue&type=style&index=0&id=97099fd6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__